/* UploadSummaryVeilComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./UploadSummaryVeilRenderer");

/**
 * UploadSummaryVeilComponent
 *
 * Component for displaying the summary of an offline upgrade upload/import
 *
 * @class
 * @extends EventEmitter
 * @listens UploadSummaryVeilComponent#event:Shutdown
 * @fires UploadSummaryVeilComponent#event:Ok
 */
class UploadSummaryVeilComponent extends EventEmitter {
    /**
     * @param {Object} importResults - Results of the offline upgrade upload/import
     * @param {Object} logger - Logger instance for logging warnings/errors
     */
    constructor(importResults, logger) {
        super();
        this._logger = logger;
        this._importResults = importResults;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    /**
     * Register any listeners needed for this component
     */
    _registerListeners() {}

    /**
     * Unregister listeners for this component
     */
    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    /**
     * Get the renderer instance for this component
     * @returns {UploadSummaryVeilRenderer}
     */
    get renderer() {
        return this.getRenderer();
    }

    /**
     * Get the logger for this component
     * @returns {Object}
     */
    get logger() {
        return this._logger;
    }

    /**
     * Retrieve the renderer instance
     * @returns {UploadSummaryVeilRenderer}
     */
    getRenderer() {
        return this._renderer;
    }

    /**
     * Clean up and shutdown the component, unregistering listeners and shutting down the renderer
     * @returns {Promise}
     */
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger &&
                    this._logger.warn({error: err}, "UploadSummaryVeilComponent.shutdown() error.");
            }
        );
    }

    /**
     * Handler for the OK button: resolves the UI context
     */
    sendOk() {
        this._context.resolve({});
    }

    /**
     * Set the $teve UI context for this component
     * @param {Object} context
     */
    set "$teve.ui.context"(context) {
        //jshint ignore:line
        this._context = context;
    }

    /**
     * Get the import results for rendering/logging
     * @returns {Object}
     */
    getImportResults() {
        return this._importResults;
    }

    /**
     * Alias for getImportResults
     * @returns {Object}
     */
    get importResults() {
        return this.getImportResults();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = UploadSummaryVeilComponent;
